<div class="currency" [ngClass]="{ 'bg-white': !fromTrading && !compact, 'currency--compact': compact, 'disabled': !tc.purchasePrice || !tc.salesPrice }" (click)="onContainerClick($event)">
  <div class="currency-header" [class.currency-header--compact]="compact">
    <div class="currency-toggle" *ngIf="!compact">
      <div class="currency-toggle__container">
        <img
          src="assets/icons/ic_coin_sol_alt.svg"
          width="24"
          height="24"
          alt=""
          [ngStyle]="{'opacity': currency.code === 'PEN' ? '0' : '1' }"
        />
        &nbsp;&nbsp;
        <img
          src="assets/icons/ic_coin_dollar_alt.svg"
          width="24"
          height="24"
          alt=""
          [ngStyle]="{'opacity': currency.code === 'USD' ? '0' : '1' }"
        />
        <button
          class="currency-toggle__button"
          [ngClass]="{ active: currency.symbol === '$' }"
          (click)="changeCurrency()"
          [disabled]="!tc.purchasePrice || !tc.salesPrice"
        >
          <span class="flex align-items-center">
            <img
              [src]="
                currency.symbol === '$'
                  ? 'assets/icons/ic_coin_dollar.svg'
                  : 'assets/icons/ic_coin_sol.svg'
              "
              width="24"
              height="24"
              alt=""
            />
          </span>
        </button>
      </div>
      <p class="t-12-500-dark text-center">
        TC:
        {{
          fromTrading && tradingType === "BUY" ? tc.salesPrice : tc.purchasePrice
        }}
        {{ fromTrading ? "es referencial" : "" }}
      </p>
    </div>
    <div class="currency-toggle__container currency-toggle__container--standalone" *ngIf="compact">
      <img src="assets/icons/ic_coin_sol_alt.svg" width="24" height="24" alt="" [ngStyle]="{'opacity': currency.code === 'PEN' ? '0' : '1' }" />
      &nbsp;&nbsp;
      <img src="assets/icons/ic_coin_dollar_alt.svg" width="24" height="24" alt="" [ngStyle]="{'opacity': currency.code === 'USD' ? '0' : '1' }" />
      <button
        class="currency-toggle__button"
        [ngClass]="{ active: currency.symbol === '$' }"
        (click)="changeCurrency(); $event.stopPropagation()"
        [disabled]="!tc.purchasePrice || !tc.salesPrice"
      >
        <span class="flex align-items-center">
          <img
            [src]="currency.symbol === '$' ? 'assets/icons/ic_coin_dollar.svg' : 'assets/icons/ic_coin_sol.svg'"
            width="24"
            height="24"
            alt=""
          />
        </span>
      </button>
    </div>
    <p-button
      *ngIf="showRefreshButton"
      [text]="true"
      severity="secondary"
      class="refresh-button-large"
      pTooltip="Actualizar"
      tooltipPosition="bottom"
      (click)="onRefreshClick(); $event.stopPropagation()"
    >
      <img src="assets/icons/ico_refresh.svg" width="16" height="16" alt="" aria-hidden="true" />
      <span>Actualizar</span>
    </p-button>
  </div>
</div>
